// @ts-nocheck
import * as React from "react";

const ArrowDownward: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="m12 21-6.346-6.347.689-.688 5.158 5.152V2.98h1v16.118l5.157-5.158.689.713L12 21Z"
            />
        </svg>
        /* Store Custom Code - End */
    );
};

export default React.memo(ArrowDownward);
